export const ROUTES = {
  home: '/',
  assistant: '/assistant',
  depotRdv: '/depots',
  depots: '/depots',
  login: '/login',
  googleCallback: '/auth/google/callback',
  iti: {
    domainesOvh: '/iti/domaines/ovh',
    domaineOvhDetail: (id) => `/iti/domaines/ovh/${id}`,
    domainesGandi: '/iti/domaines/gandi',
    domaineGandiDetail: (id) => `/iti/domaines/gandi/${id}`,
    hebergementSites: '/iti/hebergement/sites',
    hebergementSiteDetail: (id) => `/iti/hebergement/sites/${id}`,
    chiffrageSite: '/iti/chiffrage/site',
    maintenanceMails: '/iti/maintenance/mails',
    admin: '/iti/admin',
    adminSection: (section = 'variables') => `/iti/admin/${section}`,
  },
  admin: {
    users: '/admin/users',
    usersAdd: '/admin/users/add',
    usersEdit: (id) => `/admin/users/edit/${id}`,
    clientMapping: '/admin/correspondances-clients',
    clients: '/admin/clients',
    menuVisibility: '/admin/menu-visibility',
    skills: '/admin/skills',
    mcpDomains: '/admin/mcp-domains',
    commerciaux: '/admin/commerciaux',
    commercialNew: '/admin/commerciaux/new',
    commercialEdit: (id) => `/admin/commerciaux/${id}`,
  },
  secteurs: {
    carte: '/secteurs/carte',
    entreprises: '/secteurs/entreprises',
    entrepriseDetail: (id) => `/secteurs/entreprises/${id}`,
    dashboard: '/secteurs/dashboard',
    admin: '/secteurs/admin',
    adminSecteurs: '/secteurs/admin/secteurs',
    adminSecteurNew: '/secteurs/admin/secteurs/new',
    adminSecteurEdit: (id) => `/secteurs/admin/secteurs/${id}`,
    adminZones: '/secteurs/admin/zones',
    adminZoneEdit: (id) => `/secteurs/admin/zones/${id}`,
    adminCommerciaux: '/secteurs/admin/commerciaux',
    adminCommercialNew: '/secteurs/admin/commerciaux/new',
    adminCommercialEdit: (id) => `/secteurs/admin/commerciaux/${id}`,
    adminEntreprises: '/secteurs/admin/entreprises',
    adminEntrepriseNew: '/secteurs/admin/entreprises/new',
    adminEntrepriseEdit: (id) => `/secteurs/admin/entreprises/${id}`,
    adminProduitsSociete: '/secteurs/admin/produits-societe',
    adminProduits: '/secteurs/admin/produits',
    adminProduitsCommerciaux: '/secteurs/admin/produits-commerciaux',
    adminEntreprisesProduits: '/secteurs/admin/entreprises-produits',
    adminZonePolygon: (id) => `/secteurs/admin/zones/${id}/polygon`,
    adminCommandes: '/secteurs/admin/commandes',
  },
  kkp: {
    hub: '/kkp',
    planningMag: '/kkp/planning/mag',
    planningSet: '/kkp/planning/set',
    distrib: '/kkp/distribution',
    distribZones: '/kkp/distribution/zones',
    distribCarte: '/kkp/distribution/carte',
    distribCarteVilles: '/kkp/distribution/carte-villes',
    distribCommentaires: '/kkp/distribution/commentaires',
    distribLivraisons: '/kkp/distribution/livraisons',
    planningNewsletter: '/kkp/planning/newsletter',
    planningWeb: '/kkp/planning/web',
    cdfMag: '/kkp/cdf/mag',
    cdfPubGraphiste: '/kkp/cdf/mag/pub-graphiste',
    bilanAudience: '/kkp/bilan-audience',
    crons: '/kkp/crons',
    sommaireMag: '/kkp/sommaire',
    planDeComHub: '/kkp/chiffrage',
    planDeCom: '/kkp/plan-de-com',
    bdcSignature: '/kkp/plan-de-com/bdc',
    mediaPlanning: '/kkp/plan-de-com/media-planning',
    planDeComAdmin: '/kkp/admin/chiffrage',
    admin: '/kkp/admin',
    adminSection: (section = 'mag') => `/kkp/admin/${section}`,
    adminCommerciaux: '/kkp/admin/commerciaux',
    adminCommercialNew: '/kkp/admin/commerciaux/new',
    adminCommercialEdit: (id) => `/kkp/admin/commerciaux/${id}`,
    /** @deprecated utilisez admin / adminSection */
    adminReferentiels: '/kkp/admin/mag',
    /** @deprecated utilisez adminSection('newsletter') */
    adminNewsletter: '/kkp/admin/newsletter',
  },
  klub: {
    dashboard: '/klub',
    adherents: '/klub/adherents',
    adherentNew: '/klub/adherents/nouveau',
    adherentDetail: (id) => `/klub/adherents/${id}`,
    adherentSalaries: (id) => `/klub/adherents/${id}/salaries`,
    etapeMail: (token) => `/klub/etape/${encodeURIComponent(token)}`,
    ce: '/klub/ce',
    ceListe: '/klub/ce/liste',
    avis: '/klub/avis',
    chiffrage: '/klub/chiffrage',
    magazine: '/klub/magazine',
    admin: '/klub/admin',
    adminPipeline: '/klub/admin/pipeline-template',
  },
  temps: {
    taches: '/temps/taches',
    pilotage: '/temps/pilotage',
  },
  agenda: {
    dates: '/agenda/dates',
    datesAActiver: '/agenda/dates-a-activer',
    dateNew: '/agenda/dates/nouvelle',
    dateEdit: (id) => `/agenda/dates/${id}`,
  },
};

export const PORTAL_MODULES = [
  {
    id: 'iti',
    title: 'itiConseil',
    subtitle: 'Domaines & sites web',
    description: 'Communication, hébergement web et chiffrage commercial.',
    icon: 'mdi:web',
    color: 'orange',
    available: true,
    to: ROUTES.iti.domainesOvh,
  },
  {
    id: 'kkp',
    title: 'Koikispass',
    subtitle: 'Planning des ventes',
    description: 'MAG, SET, WEB, newsletters et chiffrage Koikispass.',
    icon: 'mdi:bullhorn',
    color: 'danger',
    available: true,
    to: ROUTES.kkp.planningMag,
  },
  {
    id: 'klub',
    title: 'Klub',
    subtitle: 'Sites Klub',
    description: 'Sites Klub, pipeline onboarding, CE et avis clients.',
    icon: 'mdi:account-group',
    color: 'pink',
    available: true,
    to: ROUTES.klub.dashboard,
  },
  {
    id: 'projets',
    title: 'Temps',
    subtitle: 'Gestion de projets',
    description: 'Tâches de production issues des commandes Dolibarr.',
    icon: 'mdi:clipboard-list',
    color: 'info',
    available: true,
    to: ROUTES.temps.taches,
  },
  {
    id: 'secteurs',
    title: 'Secteurs',
    subtitle: 'Prospection & territoires',
    description: 'Carte des zones, entreprises SIRENE et statistiques commerciales.',
    icon: 'mdi:map-marker-radius',
    color: 'success',
    available: true,
    to: ROUTES.secteurs.dashboard,
  },
];
